export const productStatus = {
    'En Revisión': { className: 'statusReviewing', text: 'En Revisión' },
    'Autorizando': { className: 'statusAuthorizing', text: 'Autorizando' },
    'Procesando': { className: 'statusProcessing', text: 'Tramitando' },
    'Hecho': { className: 'statusDone', text: 'Hecho' }
}